import React, { useState } from "react";
import Header from "../../commons/header/header";
import Footer from "../../commons/footer/footer";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
  Typography,
} from "@mui/material";
import "./iqac.css"; // Import the CSS file
import image3 from "../../../assests/images/iqac.jpg";

const IQAC = () => {
  const [selectedTab, setSelectedTab] = useState("visionMission");

  const rows = [
    {
      id: 1,
      name: "Dr. K. M. Savithri",
      designation: "PRINCIPAL",
      category: "Chair person",
    },
    {
      id: 2,
      name: "Dr. S. Aejitha",
      designation: "HOD / S & H",
      category: "IQAC Coordinator",
    },
    {
      id: 3,
      name: "Mr. S. Prabhu",
      designation: "CEO",
      category: "Member from Management",
    },
    {
      id: 4,
      name: "Mr. T. Babu Senthilkumar",
      designation: "ADMINISTRATIVE OFFICER",
      category: "Administrative Office",
    },
    {
      id: 5,
      name: "Mr. D. Senthilbabu",
      designation: "HOD / BME",
      category: "Assistant Professor",
    },
    {
      id: 6,
      name: "Mr. V. Gowthaman",
      designation: "HOD / CSE",
      category: "Associate Professor",
    },
    {
      id: 7,
      name: "Mrs. S. Nancy Priya",
      designation: "HOD / AGRI",
      category: "Assistant Professor",
    },
    {
      id: 8,
      name: "Mr. M.S. Praveen",
      designation: "HOD / MECH",
      category: "Assistant Professor",
    },
    {
      id: 9,
      name: "Mrs. N. Renugadevi",
      designation: "HOD / EEE",
      category: "Assistant Professor",
    },
    {
      id: 10,
      name: "Dr. A. Thirunavukkarasu",
      designation: "HOD / AI & DS",
      category: "Professor",
    },
    {
      id: 11,
      name: "Mr. V. Govindharajan",
      designation: "President, Kondayampalayam Village Panchayat",
      category: "LOCAL SOCIETY",
    },
    {
      id: 12,
      name: "Mr. B. Suthi",
      designation: "IV YEAR / CSE",
      category: "Student",
    },
    {
      id: 13,
      name: "Ms. G. Sindhumathi",
      designation: "ALUMNI (2023- Batch)",
      category: "Alumni",
    },
    {
      id: 14,
      name: "Mr. R. Jeevananthan",
      designation: "Software Engineer, Clover Infotech Pvt. Ltd, Chennai",
      category: "Employers",
    },
    {
      id: 15,
      name: "Mr. M. Ponraj",
      designation: "CEO, HITAJE Groups, Kurumpapalayam, Coimbatore",
      category: "Industrialists",
    },
    {
      id: 16,
      name: "Mr. T. Nagaraj",
      designation: "F / o. N. Naveen / III - CSE",
      category: "Stakeholders",
    },
  ];

  const handlePDFClick = () => {
    window.open(
      `${process.env.PUBLIC_URL}/pdf/iqac_minutes_of_meeting.pdf`,
      "_blank"
    );
  };

    const handleIqacEventsClick = () => {
    window.open(
      `${process.env.PUBLIC_URL}/pdf/iqac_events.pdf`,
      "_blank"
    );
  };
  return (
    <>
      <Header />
      <div className="image-section">
        <img src={image3} alt="Gallery" className="department-image" />
        <div className="overlay-text">IQAC</div>
      </div>
      <div className="antiragging-container">
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          width="100%"
        >
          {/* Left side menu */}
          <Box
            flex={{ xs: "none", sm: "0 0 200px" }}
            bgcolor="transparent"
            p={2}
            display="flex"
            flexDirection="column"
            alignItems="stretch"
            gap={1}
            sx={{
              "@media (max-width: 600px)": {
                flex: "0 0 auto",
              },
              "@media (min-width: 600px)": {
                flex: "0 0 200px",
              },
            }}
          >
            <Button
              variant={
                selectedTab === "visionMission" ? "contained" : "outlined"
              }
              onClick={() => setSelectedTab("visionMission")}
              style={{
                width: "100%",
                color: selectedTab === "visionMission" ? "#FFF" : "#000",
                borderColor:
                  selectedTab === "visionMission" ? "#FFF" : "#80deea",
                borderWidth: "2px",
              }}
            >
              Vision & Mission
            </Button>
            <Button
              variant={selectedTab === "committee" ? "contained" : "outlined"}
              onClick={() => setSelectedTab("committee")}
              style={{
                width: "100%",
                color: selectedTab === "committee" ? "#FFF" : "#000",
                borderColor: selectedTab === "committee" ? "#FFF" : "#80deea",
                borderWidth: "2px",
              }}
            >
              IQAC Committee
            </Button>

<Button
              variant={selectedTab === "mom" ? "contained" : "outlined"}
              onClick={handleIqacEventsClick}
              style={{
                width: "100%",
                color: selectedTab === "mom" ? "#FFF" : "#000",
                borderColor: selectedTab === "mom" ? "#FFF" : "#80deea",
                borderWidth: "2px",
              }}
            >
              IQAC Events
            </Button>

            <Button
              variant={selectedTab === "mom" ? "contained" : "outlined"}
              onClick={handlePDFClick}
              style={{
                width: "100%",
                color: selectedTab === "mom" ? "#FFF" : "#000",
                borderColor: selectedTab === "mom" ? "#FFF" : "#80deea",
                borderWidth: "2px",
              }}
            >
              Minutes of Meeting
            </Button>
          </Box>

          {/* Right side content */}
          <Box flex="1" p={2}>
            {selectedTab === "committee" && (
              <>
                <Typography variant="h4" gutterBottom>
                  IQAC Committee
                </Typography>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{ backgroundColor: "#01366b", color: "white" }}
                        >
                          S.No.
                        </TableCell>
                        <TableCell
                          sx={{ backgroundColor: "#01366b", color: "white" }}
                        >
                          Name of the Members
                        </TableCell>
                        <TableCell
                          sx={{ backgroundColor: "#01366b", color: "white" }}
                        >
                          Designation
                        </TableCell>
                        <TableCell
                          sx={{ backgroundColor: "#01366b", color: "white" }}
                        >
                          Category
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row, index) => (
                        <TableRow
                          key={row.id}
                          style={{
                            backgroundColor:
                              index % 2 === 0 ? "white" : "#f1f8e9",
                          }}
                        >
                          <TableCell>{row.id}</TableCell>
                          <TableCell>{row.name}</TableCell>
                          <TableCell>{row.designation}</TableCell>
                          <TableCell>{row.category}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}
            {selectedTab === "visionMission" && (
              <>
                <Typography variant="h4" gutterBottom>
                  Internal Quality Assurance Cell (IQAC)
                </Typography>
                <Typography variant="h5" gutterBottom>
                  Vision
                </Typography>
                <ul>
                  <li>
                    To monitor and develop systematic quality processes of the
                    college for evolving, enhancing, and sustaining excellence
                    in academic and administrative practices, also ensuring
                    significant growth and achievements in all aspects of the
                    institution.
                  </li>
                </ul>

                <Typography variant="h5" gutterBottom>
                  Mission
                </Typography>
                <ul>
                  <li>
                    To motivate faculty to create a student learning-centric
                    environment, using ICT tools for teaching and learning
                    processes, as well as inculcate a value-based education
                    system.
                  </li>
                  <li>
                    To inculcate research activities among faculty and students.
                  </li>
                  <li>
                    To measure the annual progress of departments by external
                    Academic and Administrative Audit.
                  </li>
                  <li>
                    To build association with all stakeholders and to stir
                    social responsibility among them.
                  </li>
                </ul>
                <Typography variant="h5" gutterBottom>
                  Objectives
                </Typography>
                <ul>
                  <li>To achieve academic and administrative excellence.</li>
                  <li>
                    Creating a student-centric atmosphere for holistic learning.
                  </li>
                  <li>
                    Promote institutional measures aimed at enhancing quality by
                    internalizing quality circles and institutionalizing best
                    practices.
                  </li>
                  <li>
                    To encourage all departments to organize seminars, webinars,
                    workshops, conferences, symposia, and academic programs.
                  </li>
                  <li>
                    The development of an institution database and documentation
                    of all programs leads to quality improvement.
                  </li>
                </ul>
              </>
            )}
            {selectedTab === "mom" && (
              <Typography variant="h4" gutterBottom>
                Minutes of Meeting
              </Typography>
            )}
          </Box>
        </Box>
      </div>
      <Footer />
    </>
  );
};

export default IQAC;
